import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { RegieBaremeKey, RegieBaremeScalars } from "../../interface/regie";

export const setRegieBareme = async (
  key: RegieBaremeKey,
  value: number,
  token: string,
  setScalars: (scalars: RegieBaremeScalars) => void,
  dispatch: Function,
  setError: Function
) => {
  try {
    const response = await axios.post(
      `${urlAPI}/regie/baremes`,
      { key, value },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setScalars(response.data.message);
    dispatch(showSnackbar("Barème régie mis à jour avec succès.", "success"));
  } catch (error: any) {
    console.error(error);
    setError(error?.response?.data?.error || "Impossible de mettre à jour ce barème.");
    dispatch(showSnackbar("Erreur lors de la mise à jour du barème régie.", "error"));
  }
};
